'use strict';

const Enum = require('./enum');

/**
 * Battery voltage of Luna Pro Plus is beyond current normal range
 * Define new value to compatible with current prediction logic
 */
const LunaProPlusBatteryPredictParams = {
  zScore: -2,
  batteryChangeDelta: 400,
  batteryLogMaxVoltage: 8800,
  batteryLogMinVoltage: 6000,
  batteryFullVoltage: 8200,
  batteryMinLiIonRechargeableChangeVoltage: 8300,
  batteryMinLiIonRechargeableWarningVoltage: 8300,
  batteryRemainingPercentageToVoltage: {
    '100-Infinity': 8300,
    '95-100': 8100,
    '90-95': 7960,
    '85-90': 7850,
    '80-85': 7740,
    '75-80': 7630,
    '70-75': 7520,
    '65-70': 7430,
    '60-65': 7340,
    '55-60': 7270,
    '50-55': 7230,
    '45-50': 7180,
    '40-45': 7140,
    '35-40': 7110,
    '30-35': 7070,
    '25-30': 7020,
    '20-25': 6970,
    '15-20': 6920,
    '10-15': 6840,
    '8-10': 6800,
    '6-8': 6750,
    '3-6': 6600,
    '2-3': 6500,
    '0-2': 6400,
  },
};

module.exports.BatteryPredictParamsTypes = Object.create(Enum, {
  LUNA_PRO_PLUS: { value: 'luna_pro_plus', enumerable: true },
  toParams: {
    value: function(type) {
      switch (type) {
        case this.LUNA_PRO_PLUS:
          return LunaProPlusBatteryPredictParams;

        default:
          return null;
      }
    },
    enumerable: false,
  },
});
